module.exports = __webpack_public_path__ + "img/pay-coll.82444354.png";